import { z } from 'zod'

/**
 * Mensagens do Zod em português do Brasil. O Zod só traz `pt`, que é de
 * Portugal ("ficheiro", "registo", "Demasiado grande"), e o padrão é inglês.
 * A mensagem chega à tela pelo erro da API e pelos formulários, então fala com
 * quem usa, não com quem programa.
 */

const UNIDADE: Record<string, string> = {
  string: 'caracteres',
  array: 'itens',
  set: 'itens',
  map: 'itens',
  file: 'bytes',
}

const FORMATO: Record<string, string> = {
  email: 'E-mail inválido.',
  url: 'Link inválido.',
  uuid: 'Identificador inválido.',
  datetime: 'Data e hora inválidas.',
  date: 'Data inválida.',
  time: 'Hora inválida.',
  e164: 'Telefone inválido.',
  regex: 'Formato inválido.',
}

const TIPO: Record<string, string> = {
  string: 'um texto',
  number: 'um número',
  int: 'um número inteiro',
  boolean: 'sim ou não',
  date: 'uma data',
  array: 'uma lista',
  object: 'um objeto',
}

function erroPtBr(issue: z.core.$ZodRawIssue): string | undefined {
  switch (issue.code) {
    case 'invalid_type':
      if (issue.input === undefined || issue.input === null) return 'Campo obrigatório.'
      return `Valor inválido: esperava ${TIPO[issue.expected] ?? 'outro tipo'}.`
    case 'too_small': {
      const unidade = UNIDADE[issue.origin] ?? ''
      if (issue.origin === 'string' && Number(issue.minimum) === 1) return 'Campo obrigatório.'
      if (unidade === '') return `Precisa ser no mínimo ${issue.minimum}.`
      return `Precisa de pelo menos ${issue.minimum} ${unidade}.`
    }
    case 'too_big': {
      const unidade = UNIDADE[issue.origin] ?? ''
      if (unidade === '') return `Precisa ser no máximo ${issue.maximum}.`
      return `Aceita no máximo ${issue.maximum} ${unidade}.`
    }
    case 'invalid_format':
      return FORMATO[issue.format] ?? 'Formato inválido.'
    case 'not_multiple_of':
      return `Precisa ser múltiplo de ${issue.divisor}.`
    case 'invalid_value':
      return 'Opção inválida.'
    case 'unrecognized_keys':
      return 'Campo não reconhecido.'
    case 'invalid_union':
    case 'invalid_key':
    case 'invalid_element':
      return 'Valor inválido.'
    case 'custom':
      return 'Valor inválido.'
    default:
      return undefined
  }
}

/** Chamado uma vez na entrada de cada app, antes de qualquer schema rodar. */
export function zodEmPortugues(): void {
  z.config({ localeError: erroPtBr })
}
